import React from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
import Dashboard from "./Dashboard";

const UseOfSoldProductsDashboard = () => {
  const { user } = useUser();

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <Scope3Layout />}
    >
      <Unauthorized requiredModule="Environment | Scope 3 | Use of Sold Products">
        <Dashboard />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default UseOfSoldProductsDashboard;
